/**
 * Star Battle entry point.
 *
 * The whole game is client-side: the server sends a shell and this bundle, and
 * nothing else ever goes over the network. The service worker below is what
 * makes that true on a second visit as well as a first.
 */

import { render } from 'preact';
import { App } from './app';

const root = document.getElementById('starbattle');
if (root) {
  // The shell ships a "Loading Star Battle…" placeholder for the moment before
  // this script runs. Preact renders *alongside* DOM it did not create rather
  // than replacing it, so without clearing the container first the placeholder
  // stays on the page below the game, holding open the 60vh it reserves.
  root.replaceChildren();
  render(<App />, root);
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Scope is /starbattle/, which is why the page lives at a trailing slash:
    // a worker cannot control a URL above the directory it is served from.
    void navigator.serviceWorker.register('/starbattle/service-worker.js').catch(() => {
      // Offline support is a bonus; a refused registration (private browsing,
      // an insecure origin) must not stop the game loading.
    });
  });
}
